//格式化时间
Date.prototype.Format = function (fmt) {
    const o = {
        "M+": this.getMonth() + 1, //月份
        "d+": this.getDate(), //日
        "H+": this.getHours(), //小时
        "m+": this.getMinutes(), //分
        "s+": this.getSeconds(), //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        "S": this.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (const k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}

//调用
export const timeStr = new Date().Format("yyyyMMddHHmmss");
//获取当前时间
export const nowTime = new Date().Format("yyyy-MM-dd HH:mm:ss");

//传入格式获取当前时间
export function getNowTime(format){
    return new Date().Format(format);
}

export function timefilters(date){
    if(!date){
        return null
    }
    var dates=new Date(date)
    if(JSON.stringify(dates)=='null'){
        var date1=date.replace(/-/g,'/').replace('T',' ').slice(0,19)
        dates=new Date(date1)
    }
    return dates.Format("yyyy-MM-dd HH:mm:ss");
}



//获取多少天之前的日期，num等于0获取当天的，-1前一天的,+1后一天的，time不传为当前时间
export function getBeforeDate(num, time){
            let n = num;
            let d = '';
            if(time) {
                d = new Date(time);
            } else {
                d = new Date();
            }
            let year = d.getFullYear();
            let mon = d.getMonth() + 1;
            let day = d.getDate();
            if(day <= n) {
                if(mon > 1) {
                    mon = mon - 1;
                } else {
                    year = year - 1;
                    mon = 12;
                }
            }
            d.setDate(d.getDate() + n);
            year = d.getFullYear();
            mon = d.getMonth() + 1;
            day = d.getDate();
            let s = year + "-" + (mon < 10 ? ('0' + mon) : mon) + "-" + (day < 10 ? ('0' + day) : day);
            return s;
    
}

//获取当月1号0点到当前日期23点59
export function getCurrentMonthTime() {//当月的时间 如：今天是8.8 则获取8.1-8.8时间
    var TimeNow = new Date();
    var startDay1 = new Date(TimeNow.getFullYear(), TimeNow.getMonth(), 1);//当月1号
    var endDay1 = new Date(TimeNow.getFullYear(), TimeNow.getMonth(), TimeNow.getDate(), 23, 59, 59);//23:59:59 将结束时间改成前一天
    return [startDay1, endDay1];
    }